export default __webpack_public_path__ + "316490e891f338721460d9d8972f98ab.png";